import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { Button, Grid, List, Loader } from 'semantic-ui-react';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import { Activity } from '../../../app/models/activity';
import { PaginationParams } from '../../../app/models/paginationParams';
import { useStore } from '../../../app/stores/store';
import ActivityDetails from '../details/ActivityDetails';
import ActivityForm from '../form/ActivityForm';
import ActivityFilters from './ActivityFilters';
import ActivityList from './ActivityList';
import ActivityListItemPlaceholder from './ActivityListItemPlaceholder';

// interface Props {
//     activities: Activity[];
//     //selectedActivity: Activity | undefined;
//     //selectActivity: (id: string) => void;
//     //cancelSelectActivity: () => void;
//     //editMode: boolean;
//     //openForm: (id: string) => void;
//     //closeForm: () => void;
//     //cearteOrEdit: (activity: Activity) => void ;
//     //deleteActivity: (id: string) => void;
//     //submitting: boolean;
// }

// export default function ActivityDashboard(props: Props) {
//     return (
//         <Grid>
//             <Grid.Column width='10'>
//                 <List>
//                     {/* {props.activities. map((activity: any) => ( */}
//                     {props.activities. map(activity => (
//                         <List.Item key={activity.id}>
//                         {activity.title}
//                         </List.Item>
//                     ))}
//                 </List>
//             </Grid.Column>
//         </Grid>
//     )

//export default observer( function ActivityDashboard(props: Props) { //'.
export default observer( function ActivityDashboard() {
    const usStore= useStore(); //'n
    const [loadingNext, setLoadingNext] = useState(false); //'n local state

    useEffect(() => { //' n
        //usStore.activityStore.loadActivities();
        if(usStore.activityStore.activityRegistryMap.size <= 1) {
            usStore.activityStore.loadActivities();
        }
    //}, [usStore.activityStore])
    }, [usStore.activityStore.loadActivities, usStore.activityStore.activityRegistryMap.size])

    //if (usStore.activityStore.loadingInitial) return <LoadingComponent content='Loading activities...' /> //'o
    //if (usStore.activityStore.loadingInitial && !loadingNext) return <LoadingComponent content='Loading activities...' /> //'n

    function handleLoadingNext() { //'n
        setLoadingNext(true);
        usStore.activityStore.setPagingParams(new PaginationParams(usStore.activityStore.paginationHeader!.pageNumber + 1));
        usStore.activityStore.loadActivities().then(() => {
            setLoadingNext(false);
        });
    }

    return (
        <Grid>
            <Grid.Column width='10'>
                {/* <List> */}
                {/* {props.activities. map((activity: any) => ( */}
                {/* {props.activities. map(activity => (
                            <List.Item key={activity.id}>
                            {activity.title}
                            </List.Item>
                        ))}
                    </List> */}

                {/* <ActivityList activities={props.activities} selectActivity={props.selectActivity} deleteActivity={props.deleteActivity} submitting={props.submitting} /> */}
                {/* <ActivityList activities={props.activities} deleteActivity={props.deleteActivity} submitting={props.submitting} /> */}

                {/* <ActivityList /> */}
                {/* <Button 
                    content='More...' 
                    positive 
                    floated='right' 
                    loading={loadingNext} 
                    disabled={usStore.activityStore.paginationHeader?.totalPages === usStore.activityStore.paginationHeader?.pageNumber}
                    onClick={handleLoadingNext} 
                /> */}

                {/* <InfiniteScroll 
                    pageStart={0} 
                    loadMore={handleLoadingNext}
                    hasMore={!loadingNext && !!usStore.activityStore.paginationHeader && usStore.activityStore.paginationHeader.pageNumber < usStore.activityStore.paginationHeader.totalPages}
                    initialLoad={false}
                >
                    <ActivityList />
                </InfiniteScroll> */}

                {usStore.activityStore.loadingInitial && !loadingNext ? (
                    <>
                        <ActivityListItemPlaceholder />
                        <ActivityListItemPlaceholder />
                    </>
                ) : (
                    <InfiniteScroll 
                        pageStart={0} 
                        loadMore={handleLoadingNext}
                        hasMore={!loadingNext && !!usStore.activityStore.paginationHeader && usStore.activityStore.paginationHeader.pageNumber < usStore.activityStore.paginationHeader.totalPages}
                        initialLoad={false}
                    >
                        <ActivityList />
                    </InfiniteScroll>
                )}

            </Grid.Column>
            <Grid.Column width='6'>
                {/* <ActivityDetails activity={props.activities[0]} /> */}
                {/* {props.activities[0] && <ActivityDetails activity={props.activities[0]} />} */}

                {/* {props.selectedActivity && !props.editMode && <ActivityDetails activity={props.selectedActivity} cancelSelectActivity={props.cancelSelectActivity} openForm={props.openForm} />} */}
                {/* {props.selectedActivity && !props.editMode && <ActivityDetails />} */}

                {/* {props.activities[0] && <ActivityForm activity={props.activities[0]} />} */}
                {/* {props.selectedActivity && <ActivityForm activity={props.selectedActivity} />} */}
                {/* {props.editMode && <ActivityForm activity={props.selectedActivity} closeForm={props.closeForm} cearteOrEdit={props.cearteOrEdit} submitting={props.submitting} /> } */}
                {/* {props.editMode && <ActivityForm cearteOrEdit={props.cearteOrEdit} submitting={props.submitting} /> } */}
                {/* {props.editMode && <ActivityForm />} */}

                {/* <h2>Activity filters</h2> */}

                <ActivityFilters />

            </Grid.Column>
            <Grid.Column width={10}>
                <Loader active={loadingNext} />
            </Grid.Column>
        </Grid>
    )

//} //'
}); 